module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cameras",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-btn",
    class: {
      active: _vm.isMenuActive
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickMenu()
      }
    }
  }, [_c('div', {
    staticClass: "bar first"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar second"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar fourth"
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.currentSiteId) ? _c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n      " + _vm._s(_vm.currentSite.localTimeNow().toLocaleTimeString()) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option-btns"
  }, [_c('div', {
    staticClass: "option-btn",
    class: {
      'disabled': _vm.snapshotMaxWidthIndexInUse <= 0
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickZoomOut()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "option-btn",
    class: {
      'disabled': _vm.snapshotMaxWidthIndexInUse >= _vm.snapshotMaxWidthSizes.length - 1
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickZoomIn()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.currentSiteId) ? _c('div', {
    staticClass: "cameras-container"
  }, [_c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.currentSite.cameras) ? _c('span', _vm._l((_vm.currentSite.cameras), function(cameraId) {
    return _c('div', {
      key: cameraId,
      staticClass: "camera-container",
      class: {
        'has-event': _vm.cameraIdsWithEvents[cameraId]
      },
      style: ({
        'max-width': _vm.snapshotMaxWidthSizes[_vm.snapshotMaxWidthIndexInUse] + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.onClickCamera(cameraId)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "camera-info"
    }, [_c('div', {
      staticClass: "camera-name prevent-text-overflow"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      }
    })]), _vm._v("\n                " + _vm._s(_vm.camera(cameraId).name) + "\n              ")]), _vm._v(" "), (_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("\n                  Last updated\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                  " + _vm._s(_vm.liveSnapshot(cameraId) ? _vm.currentSite.convertToLocalTime(_vm.liveSnapshot(cameraId).timestamp).toLocaleTimeString() :
      _vm.statusGetLiveSnapshot(cameraId) === 'requested' ? 'loading...' : 'no info') + "\n                ")])]) : _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("\n                  Status\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                  Offline\n                ")])])]), _vm._v(" "), (!_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "svg-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0zm0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('img', {
      attrs: {
        "src": _vm.liveSnapshot(cameraId).url
      }
    }) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isContinuousRecordingEnabled) ? _c('div', {
      staticClass: "recording-dot",
      class: {
        'inactive': !_vm.camera(cameraId).isOnline
      }
    }, [_vm._v("REC")]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('div', {
      staticClass: "old-snapshot-overlay",
      class: {
        'visible': _vm.nowTimestamp - _vm.liveSnapshot(cameraId).timestamp > 1000 * 60
      }
    }, [_vm._v("Old snapshot")]) : _vm._e()])])
  })) : _vm._e()])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2e6b5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cameras.vue
// module id = 272
// module chunks = 1